import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container, Navbar, Offcanvas } from "react-bootstrap";
import { Profile2User } from "iconsax-react";

import {
  ROUTE_TEACHER,
  ROUTE_STUDENT,
  ROUTE_PURCHASE,
  ROUTE_MY_PROFILE,
  ROUTE_AUTHENTICATION,
} from "../../../routes";

import logoSticky from "../../../image/logo6.svg";
import navbarTogglerImg from "../../../image/assets/navbar-toggler.svg";
import navbarResponsiveLogo from "../../../image/responsive-logo.svg";

import CloseButtonComponent from "../closeButton";
import NavProfileListComponent from "../navList";

import {
  NavbarLogoImg,
  SideBarSegment,
  SidebarTop,
  StyledNavbarButton,
  StyledOffcanvas,
  StyledWalletIcon,
  WalletBalanceBox,
} from "./styledNavbars";

const ResponsiveNavbarComponent = ({ className, location, user, profileDetails, list }) => {
  const [sideMenuIsShow, setSideMenuIsShow] = useState(false);
  const handleShowSideMenu = () => {
    setSideMenuIsShow(!sideMenuIsShow);
  };

  const userRoleRoute = user.userRole === "student" ? ROUTE_STUDENT : ROUTE_TEACHER;
  return (
    <Container className={`px-3 ${className}`}>
      <button className="border-0 bg-transparent" onClick={handleShowSideMenu}>
        <img src={navbarTogglerImg} alt="navbar-toggler" />
      </button>
      <StyledOffcanvas
        show={sideMenuIsShow}
        onHide={handleShowSideMenu}
        responsive="md"
        placement="end"
        className="border-0"
      >
        <Offcanvas.Header>
          <Navbar.Brand className="ps-4 py-0">
            <Link to="/">
              <NavbarLogoImg
                src={logoSticky}
                alt="azeto-main-logo"
                width="105"
                height="44"
              />
            </Link>
          </Navbar.Brand>
          <CloseButtonComponent iconSize="25" closeFunction={handleShowSideMenu} />
        </Offcanvas.Header>
        <Offcanvas.Body className="px-2">
          <SidebarTop className="px-2 pb-4">
            {user.isLogin && (
              <>
                <Link to={`${userRoleRoute}/${ROUTE_MY_PROFILE}`}>
                  <img
                    src={profileDetails.image}
                    alt="profile"
                    width="32"
                    height="32"
                    className="rounded-circle"
                  />
                  <span className="text-muted me-2">{profileDetails.fullName}</span>
                </Link>
                {/* TODO: #Future feature */}
                <WalletBalanceBox>
                  <span>
                    <StyledWalletIcon
                      size="26"
                      color="var(--secondary-color)"
                      variant="Bold"
                      className="ms-1"
                    />
                    موجودی شما:
                  </span>
                  <span>0 تومان</span>
                </WalletBalanceBox>
              </>
            )}
            <StyledNavbarButton to={ROUTE_PURCHASE}>اشتراک</StyledNavbarButton>
          </SidebarTop>
          <SideBarSegment>
            <NavProfileListComponent list={list} handleShowSideMenu={handleShowSideMenu} />
          </SideBarSegment>
        </Offcanvas.Body>
      </StyledOffcanvas>
      <Link to="/">
        <img
          src={navbarResponsiveLogo}
          alt="azeto"
          className={!user.isLogin ? "translate-middle-x" : undefined}
        />
      </Link>
      {!user.isLogin ? (
        <StyledNavbarButton
          $bgPrimary
          className="px-lg-2"
          to={{
            pathname: ROUTE_AUTHENTICATION,
            state: { prevPath: location.pathname },
          }}
        >
          <Profile2User size="15" />
          &nbsp;ورود | ثبت‌نام
        </StyledNavbarButton>
      ) : (
        <Link to={`${userRoleRoute}/${ROUTE_MY_PROFILE}`}>
          <img
            src={profileDetails.image}
            alt="profile"
            width="36"
            height="36"
            className="rounded-circle"
          />
        </Link>
      )}
    </Container>
  );
};

export default ResponsiveNavbarComponent;
